export enum ATMTerminalFeeModulus {
  FIVE_DOLLARS = 'FIVE_DOLLARS',
  TEN_DOLLARS = 'TEN_DOLLARS',
}

export default ATMTerminalFeeModulus;
